import type { UserProfileConfig } from '@/types/schema/page-configs/user-profile'

export const defaultUserProfileConfig: UserProfileConfig = {
  identifierPreference: 'CUSIP',
  separateProposalPerAccount: false,
}
